// extracted by mini-css-extract-plugin
module.exports = {"breadcrumps":"AdvertiserDetailPage_breadcrumps__30HId"};